import { createContext, useContext } from "react"

// Kept out of SessionContext.jsx so that file only exports components — a module that
// exports both a component and a hook breaks Fast Refresh and forces a full reload.
export const SessionContext = createContext(null)

export function useSession() {
  const context = useContext(SessionContext)
  if (!context) throw new Error("useSession must be used inside a SessionProvider")
  return context
}
